<div class="input-container" [ngClass]="{'menu-is-open' : matMenuTrigger.menuOpen }">
  <input
    #trigger
    #matMenuTrigger="matMenuTrigger"
    type="text"
    (input)="inputChange($event)"
    [matMenuTriggerFor]="menu"
    [placeholder]="placeholder"
    [disabled]="disabled"
  />
  <capra-icon class="search-icon" icon="icon-search"></capra-icon>
</div>

<mat-menu
  #menu="matMenu"
  class="collection-accessor-typeahead-results"
  yPosition="below"
  zPosition="before">
  <div class="inner-menu-content" [ngStyle]="{'width.px': trigger.offsetWidth}">
    <ng-content></ng-content>
  </div>
</mat-menu>
